import { getUrlWithPreviewThemeId } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'

let personalizationBadgeInitialized = false

export function initializePersonalizationBadgeTriggers() {
	if (personalizationBadgeInitialized) return
	personalizationBadgeInitialized = true

	document.addEventListener('click', (event: MouseEvent) => {
		const target = event.target as HTMLElement | null
		if (!target) return
		const trigger = target.closest<HTMLAnchorElement>(
			'.personalization-route-link'
		)
		if (!trigger) return
		if (trigger.classList.contains('disabled')) {
			event.preventDefault()
			return
		}
		if (
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		)
			return
		event.preventDefault()
		if (
			trigger.hasAttribute('data-uc-personalization-transition-trigger')
		) {
			const card = trigger.closest<HTMLElement>('.card-wrapper')
			const media = card
				? q.os<HTMLElement>(
						'[data-uc-personalization-card-media]',
						card
					)
				: undefined
			if (media)
				media.style.setProperty(
					'view-transition-name',
					'personalization-photo'
				)
		}
		window.location.href = getUrlWithPreviewThemeId(trigger.href).toString()
	})
}
